/* SOFAPRESTO — interactions du design refait (2026-10-08), en JavaScript simple.
   Remplace les composants React du site pour le thème Liquid : bandeau
   d'annonces, en-tête + menu, diaporama, familles de la collection, notice de
   montage, fauteuil-lit, nuancier, accordéon FAQ. Le panier et la fiche
   produit restent dans global.js. Rien ne bouge sous prefers-reduced-motion. */
(function () {
  'use strict';
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tous = function (sel, racine) { return Array.prototype.slice.call((racine || document).querySelectorAll(sel)); };

  /* ── Bandeau d'annonces : 4,2 s, pause au survol/focus, arrêt dès que le
        visiteur navigue lui-même ── */
  tous('[data-sfp-annonces]').forEach(function (bande) {
    var msgs = tous('.annonce__msg', bande);
    var fenetre = bande.querySelector('.annonce__fenetre');
    if (msgs.length < 2) return;
    var i = 0, timer = null, pause = false, manuel = false;
    var montre = function (n) {
      msgs[i].classList.remove('est-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('est-active');
    };
    var programme = function () {
      clearInterval(timer);
      if (!rm && !pause && !manuel) timer = setInterval(function () { montre(i + 1); }, 4200);
    };
    tous('[data-sens]', bande).forEach(function (b) {
      b.addEventListener('click', function () {
        manuel = true; fenetre.setAttribute('aria-live', 'polite');
        montre(i + Number(b.dataset.sens)); programme();
      });
    });
    ['mouseenter', 'focusin'].forEach(function (e) { bande.addEventListener(e, function () { pause = true; programme(); }); });
    ['mouseleave', 'focusout'].forEach(function (e) { bande.addEventListener(e, function () { pause = false; programme(); }); });
    programme();
  });

  /* ── Menu (dialogue modal) ── */
  var tiroir = document.getElementById('sfp-menu');
  var voile = document.querySelector('.menu-voile');
  var ouvreMenu = document.querySelector('[data-sfp-menu-ouvre]');
  var menuOuvert = false;
  var gele = function (oui) {
    document.documentElement.style.overflow = oui ? 'hidden' : '';
    if (window.__lenis) { if (oui) window.__lenis.stop(); else window.__lenis.start(); }
  };
  var fermeMenu = function () {
    if (!menuOuvert) return;
    menuOuvert = false;
    tiroir.classList.remove('est-ouvert'); voile.classList.remove('est-ouvert');
    ouvreMenu.setAttribute('aria-expanded', 'false');
    setTimeout(function () { if (!menuOuvert) { tiroir.hidden = true; voile.hidden = true; } }, rm ? 0 : 380);
    gele(false);
    ouvreMenu.focus();
  };
  if (tiroir && voile && ouvreMenu) {
    ouvreMenu.addEventListener('click', function () {
      menuOuvert = true;
      tiroir.hidden = false; voile.hidden = false;
      requestAnimationFrame(function () { tiroir.classList.add('est-ouvert'); voile.classList.add('est-ouvert'); });
      ouvreMenu.setAttribute('aria-expanded', 'true');
      gele(true);
      tiroir.querySelector('.menu-tiroir__fermer').focus();
    });
    tous('[data-sfp-menu-ferme]').forEach(function (el) { el.addEventListener('click', fermeMenu); });
    tous('a', tiroir).forEach(function (a) { a.addEventListener('click', function () { menuOuvert = false; gele(false); }); });
    document.addEventListener('keydown', function (e) {
      if (!menuOuvert) return;
      if (e.key === 'Escape') { fermeMenu(); return; }
      if (e.key !== 'Tab') return;
      var f = tous('a[href], button:not([disabled])', tiroir);
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    });
  }

  /* ── En-tête : pilule sombre après 80 px, cachée en descendant après 160 px ── */
  var entete = document.querySelector('[data-sfp-entete]');
  if (entete) {
    var dernierY = window.scrollY;
    var maj = function () {
      var y = window.scrollY;
      var compacte = y > 80;
      entete.classList.toggle('entete--compacte', compacte);
      if (compacte) entete.setAttribute('data-fond', 'sombre'); else entete.removeAttribute('data-fond');
      entete.style.top = compacte ? '16px' : '40px';
      var panierOuvert = document.querySelector('.sfp-panier.est-ouvert');
      entete.classList.toggle('entete--cachee', y > 160 && y > dernierY && !menuOuvert && !panierOuvert);
      dernierY = y;
    };
    maj();
    window.addEventListener('scroll', maj, { passive: true });
  }

  /* ── Diaporama du premier écran : 1re photo 5 s, puis 4,5 s ; arrêté hors
        écran et sous reduced-motion ── */
  /* Photos 2 à 7 du diaporama : adresses en attente (data-src / data-srcset) pour
     ne pas concurrencer la 1re photo au chargement ; posées une fois la page
     chargée, ou juste avant d'être montrées. */
  var hydrate = function (img) {
    if (!img) return;
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
  };
  tous('[data-sfp-diaporama]').forEach(function (reel) {
    var slides = tous('.intro-reel__slide', reel);
    if (slides.length < 2 || rm) return;
    var differees = tous('img[data-sfp-differe]', reel);
    var charge = function () { setTimeout(function () { differees.forEach(hydrate); }, 400); };
    if (document.readyState === 'complete') charge(); else window.addEventListener('load', charge);
    var i = 0, timer = null, enVue = true;
    var suivant = function () {
      slides[i].classList.remove('intro-reel__slide--active');
      i = (i + 1) % slides.length;
      var img = slides[i].querySelector('img');
      hydrate(img);
      if (img && img.loading === 'lazy') img.loading = 'eager';
      slides[i].classList.add('intro-reel__slide--active');
      programme(4500);
    };
    var programme = function (delai) { clearTimeout(timer); if (enVue) timer = setTimeout(suivant, delai); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        enVue = e[0].isIntersecting;
        if (enVue) programme(4500); else clearTimeout(timer);
      }, { threshold: 0.05 }).observe(reel);
    }
    programme(5000);
  });

  /* ── Collection de l'accueil : Canapés / Fauteuils ── */
  tous('[data-sfp-familles]').forEach(function (groupe) {
    var section = groupe.closest('section');
    var noms = section.querySelector('[data-sfp-famille-noms]');
    var boutons = tous('[data-famille]', groupe);
    boutons.forEach(function (b) {
      b.addEventListener('click', function () {
        boutons.forEach(function (o) {
          var actif = o === b;
          o.setAttribute('aria-pressed', String(actif));
          o.classList.toggle('pill--nav', actif);
          o.classList.toggle('pill--ghost', !actif);
        });
        tous('[data-famille-liste]', section).forEach(function (l) { l.hidden = l.dataset.familleListe !== b.dataset.famille; });
        if (noms) noms.textContent = noms.getAttribute('data-' + b.dataset.famille);
      });
    });
  });

  /* ── Notice de montage : l'étape au milieu de l'écran devient active ── */
  tous('.notice').forEach(function (notice) {
    var etapes = tous('.notice__etape', notice);
    var photos = tous('.notice__photo', notice);
    var compteur = notice.querySelector('.notice__compteur');
    if (!etapes.length || !('IntersectionObserver' in window)) return;
    var active = function (n) {
      etapes.forEach(function (e, k) { e.classList.toggle('notice__etape--active', k === n); });
      photos.forEach(function (p, k) { p.classList.toggle('notice__photo--active', k === n); });
      if (compteur) compteur.textContent = 'Étape ' + (n + 1) + ' sur ' + etapes.length;
    };
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) active(Number(e.target.dataset.i)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    etapes.forEach(function (e) { io.observe(e); });
  });

  /* ── « Le soir, un lit. » : choix du modèle + bascule ; alternance auto
        3,2 s jusqu'au premier clic, en pause au survol ── */
  tous('[data-sfp-lit]').forEach(function (sec) {
    var donnees;
    try { donnees = JSON.parse(sec.querySelector('[data-sfp-lit-donnees]').textContent); } catch (e) { return; }
    var cadre = sec.querySelector('[aria-live="polite"]').parentNode;
    var imgs = tous('img', cadre);
    var pastille = cadre.querySelector('[aria-live="polite"]');
    var bascules = tous('.bascule__btn', sec);
    var groupeBascule = sec.querySelector('.bascule');
    var modeles = tous('.choix-modele__btn', sec);
    var modele = modeles.length ? modeles[0].textContent.trim() : Object.keys(donnees)[0];
    var etat = 0, pilote = false, pause = false, timer = null;
    var rendu = function () {
      var d = donnees[modele];
      imgs[0].src = d.plie; imgs[0].alt = modele + ' : ' + d.nom0.toLowerCase();
      imgs[1].src = d.lit; imgs[1].alt = modele + ' : le lit';
      imgs[0].style.opacity = etat === 0 ? '1' : '0';
      imgs[1].style.opacity = etat === 1 ? '1' : '0';
      pastille.children[0].textContent = etat === 0 ? d.nom0 : 'Le lit';
      pastille.children[1].textContent = etat === 0 ? d.cotes0 : d.cotes1;
      bascules[0].textContent = d.nom0;
      bascules.forEach(function (b, k) { b.setAttribute('aria-pressed', String(k === etat)); });
      groupeBascule.setAttribute('aria-label', modele + ' : ' + d.nom0.replace('Le ', '').toLowerCase() + ' ou lit');
    };
    var programme = function () {
      clearInterval(timer);
      if (!rm && !pilote && !pause) timer = setInterval(function () { etat = etat ^ 1; rendu(); }, 3200);
    };
    modeles.forEach(function (b) {
      b.addEventListener('click', function () {
        modeles.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        modele = b.textContent.trim(); etat = 0; pilote = true; rendu(); programme();
      });
    });
    bascules.forEach(function (b, k) {
      b.addEventListener('click', function () { etat = k; pilote = true; rendu(); programme(); });
    });
    cadre.addEventListener('mouseenter', function () { pause = true; programme(); });
    cadre.addEventListener('mouseleave', function () { pause = false; programme(); });
    rendu(); programme();
  });

  /* ── Nuancier : une couleur → ses modèles, son coussin, son plaid ── */
  tous('[data-sfp-nuancier]').forEach(function (carres) {
    var section = carres.closest('section');
    var boutons = tous('[data-couleur]', carres);
    boutons.forEach(function (b) {
      b.addEventListener('click', function () {
        boutons.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        tous('.nuancier__fiche', section).forEach(function (f) { f.hidden = f.dataset.couleur !== b.dataset.couleur; });
      });
    });
  });

  /* ── Fiche produit : ?coloris=X choisit le carré de tissu correspondant ;
        estimation de livraison (3 à 4 semaines) calculée comme sur le site ── */
  var fiche = document.querySelector('[data-sfp-fiche]');
  if (fiche) {
    var voulu = new URLSearchParams(location.search).get('coloris');
    if (voulu) {
      var carre = tous('[data-sfp-panneau="coloris"] [data-sfp-choix]', fiche).filter(function (b) { return b.dataset.valeur === voulu; })[0];
      if (carre && carre.getAttribute('aria-pressed') !== 'true') carre.click();
    }
    var est = fiche.querySelector('[data-sfp-estimation]');
    if (est) {
      var jour = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }); };
      est.textContent = 'entre le ' + jour(21) + ' et le ' + jour(28);
    }
  }

  /* ── Accordéon FAQ : une réponse ouverte à la fois, réponses toujours dans
        le HTML (repliées = inert, hors focus) ── */
  tous('[data-sfp-accordeon]').forEach(function (racine) {
    var boutons = tous('button[aria-controls]', racine);
    boutons.forEach(function (b) {
      b.addEventListener('click', function () {
        var ouvrir = b.getAttribute('aria-expanded') !== 'true';
        boutons.forEach(function (o) {
          var p = document.getElementById(o.getAttribute('aria-controls'));
          var actif = ouvrir && o === b;
          o.setAttribute('aria-expanded', String(actif));
          var signe = o.querySelector('span[aria-hidden]');
          if (signe) signe.style.transform = actif ? 'rotate(45deg)' : 'none';
          if (p) { p.setAttribute('data-open', String(actif)); if (actif) p.removeAttribute('inert'); else p.setAttribute('inert', ''); }
        });
      });
    });
  });
})();
